import { parseResponse } from 'utils/parseResponse';
import { endpoints } from '../endpoints';
import { getHeader } from './generalApi';

export async function getRecoveryTypes() {
  return fetch(`${endpoints.vtRecoveryTypes}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}
